import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { GlobalService } from 'src/app/services/shared/global.service';
import { VehiclesService } from 'src/app/services/vehicles/vehicles.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ViewAttachmentsService } from 'src/app/services/vehicles/view-attachments.service';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-vehicle-details',
  templateUrl: './vehicle-details.component.html',
  styleUrls: ['./vehicle-details.component.css']
})
export class VehicleDetailsComponent implements OnInit{
  public isLoading: boolean = false;
  public isUploading: boolean = false;
  public errorMessage: string | null = null;
  public successMessage: string | null = null;
  public vehicle_id: string = '';
  public chassis_no: string | null = null;
  public userPermissions: string[] = [];
  vehicle: any;
  photos: any[] = [];
  port_photos: any[] = [];
  port_video: any;
  video_url: string="";
  spare_parts: any[] = [];
  spare_parts_columns: any[] = [];
  public vehicle_status:string='';
  attachments: any[] = [];
  public popupErrorMessage: string | null = null;
  public popupSuccessMessage: string | null = null;
  public popupWarningMessage: string | null = null;
  public newAttPopupErrorMessage: string | null = null;
  public newAttPopupSuccessMessage: string | null = null;
  public newAttPopupWarningMessage: string | null = null;
  replacementFileName: string="Choose an image or a PDF file";
  newAttachmentFileName: string="Choose an image or a PDF file";
  isProcessing: boolean = false;
  submitted: boolean = false;
  docNameIsRequired: boolean = false;
  form!: FormGroup;
  addAttachmentForm!: FormGroup;
  attachment: any;
  new_attachment: any;
  public file_url:string='';
  public upload_type:string='';
  public upload_ref:string='';
  files: File[] = [];
  selectedPhotos: any[] = []; // Array to store selected photos to delete
  public delPhotosPopupErrorMessage: string | null = null;
  duty_payments: any[] = [];
  transfer_history: any[] = [];
  sale_offers: any[] = [];
  selectedOffer: any = null;
  sale_offer_follow_ups: any[] = [];
  page: number = 1;
  count: number = 0;
  @ViewChild('DeletePhotosModal') modalDeletePhotos!: ElementRef;
  @ViewChild('UpdateVehicleAttachmentsModal') modalUpdateVehicleAttachments!: ElementRef;
  @ViewChild('AddAttachmentModal') modalAddAttachment!: ElementRef;
  @ViewChild('SaleOfferFollowUpsModal') saleOfferFollowUpsModal!: ElementRef;

  activeTab: string = 'home';

  selectTab(tab: string) {
    this.activeTab = tab;
  }

  constructor(
    private activatedRoute:ActivatedRoute,
    private vehiclesService: VehiclesService,
    private globalService: GlobalService,
    private authService: AuthService,
    private viewAttachmentsService:ViewAttachmentsService,
    private toastr: ToastrService,
    private formBuilder: FormBuilder,
  ){
    this.form = this.formBuilder.group({
      attachment: [null, Validators.required],
    });

    this.addAttachmentForm = this.formBuilder.group({
      doc_type: ['', Validators.required],
      doc_name: [''],
      new_attachment: [null, Validators.required],
    });
  }

  ngOnInit(): void {
    this.activatedRoute.paramMap.subscribe((param: Params)=>{
      this.vehicle_id = param['get']('vehicle_id')
    })

    if(this.vehicle_id){
      this.isLoading=true;
      this.getVehicleData(this.vehicle_id);

      //Get user permissions
      this.userPermissions=this.authService.getPermissions();
    }else{
      this.errorMessage="Oops! A problem was encountered while processing your request. Please refresh the page and try again!";
    }
  }

  /**
   * Get vehicle details
   * @param vehicle_id
   */
  getVehicleData(vehicle_id: string): void{
    this.vehiclesService.getVehicle(vehicle_id)
    .subscribe({
      next: (response) => {
        if (response && Object.keys(response).length === 0) {
          this.isLoading=false;
          this.errorMessage="Unable to load vehicle details. Please refresh the page and try again!";
          this.toastr.error(this.errorMessage, 'Error!');
        }else{
          this.vehicle = response;
          if(this.vehicle.status==='no_data' || this.vehicle.status.length===0){
            this.isLoading=false;
            this.errorMessage="Unable to load vehicle details. Please refresh the page and try again.";
            this.toastr.error(this.errorMessage, 'Error!');
          }else{
            //Set chassis number
            this.chassis_no = this.vehicle.data.chassis_no;

            //Determine vehicle status
            if(this.vehicle.data.status==0){
              this.vehicle_status="En route";
            }else if(this.vehicle.data.status==1){
              this.vehicle_status="At CFS";
            }else if(this.vehicle.data.status==2){
              this.vehicle_status="In Stock";
            }else if(this.vehicle.data.status==3){
              this.vehicle_status="Being Transferred";
            }else if(this.vehicle.data.status==4){
              this.vehicle_status="On Road Test";
            }else if(this.vehicle.data.status==6){
              this.vehicle_status="In Japan Stock";
            }

            this.isLoading=false;
            this.getVehicleSpareParts(this.vehicle_id); //Load spare parts
          }
        }
      },
      error: (error) => {
        this.isLoading=false;
        this.toastr.error(error, 'Error!');
      }
    });
  }

  /**
   * Get available spare parts
   * @param vehicle_id
   */
  getVehicleSpareParts(vehicle_id: string|null):void {
    this.isLoading=true;

    this.vehiclesService.fetchVehicleSpareParts(vehicle_id)
    .subscribe({
      next: (response) => {
        if(response.status==='success'){
          this.isLoading=false;
          this.spare_parts = response.data;
          this.spare_parts_columns = this.splitIntoColumns(this.spare_parts, 10);

          this.getVehiclePhotos(vehicle_id); //Load photos
        }else if(response.status==='no_data'){
          this.isLoading=false;
          this.toastr.warning(response.message, 'Warning!');
          this.getVehiclePhotos(vehicle_id); //Load photos
        }else{
          this.isLoading=false;
          this.errorMessage="Unable to load available spare parts. Please refresh the page and try again!";
          this.toastr.error( this.errorMessage, 'Error!');
          this.getVehiclePhotos(vehicle_id); //Load photos
        }
      },
      error: (error) => {
        this.isLoading=false;
        this.toastr.error(error, 'Error!');
        this.getVehiclePhotos(vehicle_id); //Load photos
      }
    });
  }

  splitIntoColumns(items: any[], itemsPerColumn: number): any[] {
    const columns = [];
    for (let i = 0; i < items.length; i += itemsPerColumn) {
        columns.push(items.slice(i, i + itemsPerColumn));
    }

    return columns;
  }

   /**
   * Get vehicle photos
   * @param vehicle_id
   */
   getVehiclePhotos(vehicle_id: string|null):void
   {
     this.isLoading=true;

     this.vehiclesService.fetchVehiclePhotos(vehicle_id)
     .subscribe({
       next: (response) => {
         if(response.status==='success'){
           this.isLoading=false;
           this.photos = response.data;
           this.getPortVerificationPhotos(this.chassis_no) // Load port verification photos
         }else if(response.status==='no_data'){
           this.isLoading=false;
           this.toastr.warning(response.message, 'Warning!');
           this.getPortVerificationPhotos(this.chassis_no) // Load port verification photos
         }else{
           this.isLoading=false;
           this.errorMessage="Unable to load supplier photos. Please refresh the page and try again!";
           this.toastr.error(this.errorMessage, 'Error!');
           this.getPortVerificationPhotos(this.chassis_no) // Load port verification photos
         }
       },
       error: (error) => {
         this.isLoading=false;
         this.toastr.error(error, 'Error!');
         this.getPortVerificationPhotos(this.chassis_no) // Load port verification photos
       }
     });
   }

   /**
   * Get vehicle port verification photos
   * @param chassis_no
   */
   getPortVerificationPhotos(chassis_no: string|null):void
   {
     this.isLoading=true;

     this.vehiclesService.fetchPortVerificationPhotos(chassis_no)
     .subscribe({
       next: (response) => {
         if(response.status==='success'){
           this.isLoading=false;
           this.port_photos = response.data;
           this.getPortVerificationVideo(this.chassis_no); // Load port video
         }else if(response.status==='no_data'){
           this.isLoading=false;
           this.toastr.warning(response.message, 'Warning!');
           this.getPortVerificationVideo(this.chassis_no);
         }else{
           this.isLoading=false;
           this.errorMessage="Unable to load port verification photos. Please refresh the page and try again!";
           this.toastr.error(this.errorMessage, 'Error!');
           this.getPortVerificationVideo(this.chassis_no);
         }
       },
       error: (error) => {
         this.isLoading=false;
         this.toastr.error(error, 'Error!');
         this.getPortVerificationVideo(this.chassis_no);
       }
     });
   }

   /**
   * Get port verification video
   * @param chassis_no
   */
  getPortVerificationVideo(chassis_no: string|null): void{
    this.isLoading=true;

    this.vehiclesService.fetchPortVerificationVideo(chassis_no)
    .subscribe({
      next: (response) => {
        if (response && Object.keys(response).length === 0) {
          this.isLoading=false;
          this.errorMessage="Unable to load port verification video. Please refresh the page and try again!";
          this.toastr.error(this.errorMessage, 'Error!');

          //Get vehicle attachments
          this.getVehicleAttachments(this.vehicle_id);
        }else{
          this.port_video = response;

          if(this.port_video.status==='no_data' || this.port_video.status.length===0){
            this.isLoading=false;
            this.toastr.warning(this.port_video.message, 'Warning!');

            //Get vehicle attachments
            this.getVehicleAttachments(this.vehicle_id);
          }else{
            this.video_url = this.port_video.data.video_url;
            this.isLoading=false;

            //Get vehicle attachments
            this.getVehicleAttachments(this.vehicle_id);
          }
        }
      },
      error: (error) => {
        this.isLoading=false;
        this.toastr.error(error, 'Error!');
        //Get vehicle attachments
        this.getVehicleAttachments(this.vehicle_id);
      }
    });
  }

   /**
   * Get vehicle attachments
   * @param vehicle_id
   */
   getVehicleAttachments(vehicle_id: string|null): void{
    this.isLoading=true;

    this.viewAttachmentsService.getVehicleAttachments(vehicle_id)
    .subscribe({
      next: (response) => {
        if(response.status==='success'){
          this.attachments = response.data;
          this.isLoading=false;
          //Load duty payment details
          this.getVehicleDutyPaymentDetails(this.vehicle_id);
        }else if(response.status==='no_data'){
          this.isLoading=false;
          this.toastr.warning(response.message, 'Warning!');
          //Load duty payment details
          this.getVehicleDutyPaymentDetails(this.vehicle_id);
        }else{
          this.errorMessage="Unable to load vehicle attachments. Please refresh the page and try again!";
          this.isLoading=false;
          this.toastr.error(this.errorMessage, 'Error!');
          //Load duty payment details
          this.getVehicleDutyPaymentDetails(this.vehicle_id);
        }
      },
      error: (error) => {
        this.isLoading=false;
        this.toastr.error(error, 'Error!');
        //Load duty payment details
        this.getVehicleDutyPaymentDetails(this.vehicle_id);
      }
    });
  }

  /**
   * Get vehicle duty payment details
   * @param vehicle_id
   */
  getVehicleDutyPaymentDetails(vehicle_id: string): void{
    this.isLoading=true;

    this.vehiclesService.fetchVehicleDutyPmtDetails(vehicle_id)
    .subscribe({
      next: (response) => {
        if(response.status==='success'){
          this.duty_payments = response.data;
          this.isLoading=false;

          //Get vehicle transfer history
          this.fetchVehicleTransferHistory(this.vehicle_id);
        }else if(response.status==='no_data'){
          this.toastr.warning(response.message, 'Warning!');
          this.isLoading=false;
          //Get vehicle transfer history
          this.fetchVehicleTransferHistory(this.vehicle_id);
        }else{
          this.errorMessage="Unable to load duty payment details. Please refresh the page and try again!";
          this.toastr.error(this.errorMessage, 'Error!');
          this.isLoading=false;
          //Get vehicle transfer history
          this.fetchVehicleTransferHistory(this.vehicle_id);
        }
      },
      error: (error) => {
        this.isLoading=false;
        this.toastr.error(error, 'Error!');
        //Get vehicle transfer history
        this.fetchVehicleTransferHistory(this.vehicle_id);
      }
    });
  }

  /**
   * Get vehicle transfer history
   */
  fetchVehicleTransferHistory(vehicle_id: string):void{
    this.isLoading=true;

    this.vehiclesService.getVehicleTransferHistory(vehicle_id)
    .subscribe({
      next: (response) => {
        if(response.status==='success'){
          this.transfer_history = response.data;
          this.isLoading=false;
          this.fetchVehicleSaleOffers(vehicle_id);
        }else if(response.status==='no_data'){
           this.toastr.warning(response.message, 'Warning!');
           this.isLoading=false;
           this.fetchVehicleSaleOffers(vehicle_id);
        }else{
          this.errorMessage="Unable to load vehicle transfer history. Please refresh the page and try again!";
          this.toastr.error(this.errorMessage, 'Error!');
          this.isLoading=false;
          this.fetchVehicleSaleOffers(vehicle_id);
        }
      },
      error: (error) => {
        this.errorMessage=error;
        this.isLoading=false;
        this.toastr.error(error, 'Error: Vehicle Transfer History!');
        this.fetchVehicleSaleOffers(vehicle_id);
      }
    });
  }

  /**
   * Get vehicle sale offers
   */
  fetchVehicleSaleOffers(vehicle_id: string):void{
    this.isLoading=true;

    this.vehiclesService.getVehicleSaleOffers(vehicle_id)
    .subscribe({
      next: (response) => {
        if(response.status==='success'){
          this.sale_offers = response.data;
          this.isLoading=false;
        }else if(response.status==='no_data'){
            this.toastr.warning(response.message, 'Warning!');
           this.isLoading=false;
        }else{
          let error="Unable to load vehicle sale offers. Please refresh the page and try again!";
          this.toastr.error(error, 'Error!');
          this.isLoading=false;
        }
      },
      error: (error) => {
        this.isLoading=false;
        this.toastr.error(error, 'Error: Sale Offers!');
      }
    });
  }

  openOfferDetails(offer: any): void {
    this.selectedOffer = offer;
  }

  /**
   * Get sale offer follow-ups.
   */
  fetchSaleOfferFollowUps(saleOfferId: number): void {
    this.isLoading = true;
    this.sale_offer_follow_ups = [];

    this.vehiclesService.getSaleOfferFollowUps(saleOfferId)
      .subscribe({
        next: (response) => {
          if (response.status === 'success') {
            this.sale_offer_follow_ups = response.data ?? [];
          } else if (response.status === 'no_data') {
            this.sale_offer_follow_ups = [];
          } else {
            this.toastr.error(
              'Unable to load sale offer follow-ups. Please try again.',
              'Error!'
            );
          }

          this.isLoading = false;
        },
        error: (error) => {
          this.isLoading = false;

          this.toastr.error(
            'Unable to load sale offer follow-ups. Please try again.',
            'Error!'
          );
        }
      });
  }

  /**
   * Open the follow-ups modal for the selected sale offer.
   */
  openFollowUps(saleOfferId: number): void {
    this.fetchSaleOfferFollowUps(saleOfferId);

    // Open the follow-ups modal after the details modal closes.
    if (this.saleOfferFollowUpsModal) {
      (<any>$(this.saleOfferFollowUpsModal.nativeElement)).modal('show');
    }else{
       this.toastr.error(
        'Unable to open sale offer follow-ups view. Please try again.',
        'Error!'
      );
    }
  }

  // Small formatting helpers used by the template
  formatCurrency(value: string | null): string {
    const num = parseFloat(value ?? '0');
    return isNaN(num) ? 'KES 0' : 'KES ' + num.toLocaleString('en-KE', { maximumFractionDigits: 0 });
  }

  formatDate(value: string): string {
    const date = new Date(value.replace(' ', 'T'));
    return date.toLocaleString('en-KE', { day: 'numeric', month: 'short', year: 'numeric', hour: 'numeric', minute: '2-digit' });
  }

  isCashDeal(offer: any): boolean {
    return offer.deal_type === 'Cash';
  }

  hasBroker(offer: any): boolean {
    return offer.deal_has_broker === 'Yes';
  }

  pageChangeEvent(event: number){
    this.page = event;
  }

   //Select image
   onSelect(event: any) {
     this.files.push(...event.addedFiles);
   }

   //Remove image
   onRemove(event: any) {
     this.files.splice(this.files.indexOf(event), 1);
   }

   /**
    * Upload vehicle photos
    */
   handleSubmit(){
     if(this.files.length===0){
       this.errorMessage="Please select atleast one vehicle photo to proceed!";
     }else{
       this.isUploading=true;

       const formData = new FormData();
       this.files.forEach(file => {
         formData.append('file[]', file);
       });

       this.vehiclesService.uploadPhotos(formData,this.vehicle_id)
       .subscribe({
         next: (response) => {
           if(response.status==='success'){
             this.isUploading=false;
             this.globalService.setGlobalSuccessMessage(response.message);
             this.errorMessage=''; //Clear error message incase it's available
             //Cleared selected images
             this.files=[];
             // Reload vehicle photos
             this.isLoading=true;
             this.getVehiclePhotos(this.vehicle_id);
           }else if(response.status==='upload_error'){
             this.isUploading=false;
             this.globalService.setGlobalWarningMessage(response.message);
             this.errorMessage=''; //Clear any caught error message incase it's available
           }else{
             this.isUploading=false;
             this.errorMessage=response.message;
           }
         },
         error: (error) => {
           this.isUploading=false;
           this.errorMessage=error;
         }
       });
     }
   }

   openDeletePhotosModal(){
     if (this.modalDeletePhotos) {
       (<any>$(this.modalDeletePhotos.nativeElement)).modal('show');
     }
   }

   closeModal():void {
     if (this.modalDeletePhotos) {
       (<any>$(this.modalDeletePhotos.nativeElement)).modal('hide');
     }
   }

   /**
    * Delete photos
    */
   deletePhotos(){
     if(this.selectedPhotos.length===0){
       this.delPhotosPopupErrorMessage="Please select photo(s) to delete!";
     }else{
       this.isLoading = true;

       this.vehiclesService.deleteVehiclesPhotos(this.vehicle_id,this.selectedPhotos)
       .subscribe({
         next: (response) => {
           if(response.status==='success'){
             this.globalService.setGlobalSuccessMessage(response.message);
             this.errorMessage=''; //Clear error message incase it's available
             this.closeModal(); //Close modal
             this.getVehiclePhotos(this.vehicle_id); // Reload vehicle photos
             this.selectedPhotos=[];  //Cleared photos selected for deletion
             this.photos=[]; //Clear photo gallery
           }else if(response.status==='error'){
             this.isLoading=false;
             this.delPhotosPopupErrorMessage = response.message;
             this.errorMessage=''; //Clear any caught error message incase it's available
           }else if(response.status==='partial_delete'){
             this.globalService.setGlobalErrorMessage(response.message);
             this.errorMessage=''; //Clear any caught error message incase it's available
             this.closeModal();  //Close modal
             // Reload vehicle photos
             this.getVehiclePhotos(this.vehicle_id);
             //Cleared selected photos
             this.selectedPhotos=[];
           }else{
             this.isLoading=false;
             this.closeModal();  //Close modal
             this.errorMessage=response.message;
           }
         },
         error: (error) => {
           this.isLoading=false;
           this.closeModal();  //Close modal
           this.errorMessage=error;
         }
       });
     }
   }

   // Function to handle checkbox change event
   checkboxChange(event: any, item: any) {
     if (event.target.checked) {
       // Add checked checkbox to the array
       this.selectedPhotos.push(item);
     } else {
       // Remove unchecked checkbox from the array
       const index = this.selectedPhotos.indexOf(item);
       if (index !== -1) {
         this.selectedPhotos.splice(index, 1);
       }
     }
   }

  //---------------------Handle Vehicle Attachments-----------------------
   /**
   * Handle selectd file
   * @param event
   */
   onReplacementAttachmentSelected(event: any) {
    //Show selected file
    const fileInput = event.target as HTMLInputElement;
    this.replacementFileName = fileInput.files?.[0]?.name ?? 'Choose an image or a PDF file';

    //Prepare file for upload
    if (event.target.files && event.target.files.length) {
      const [file] = event.target.files;
      this.attachment = file
    }
  }

  /**
   * Handle new selected file
   * @param event
   */
  onNewAttachmentSelected(event: any) {
    //Show selected file
    const fileInput = event.target as HTMLInputElement;
    this.newAttachmentFileName = fileInput.files?.[0]?.name ?? 'Choose an image or a PDF file';

    //Prepare file for upload
    if (event.target.files && event.target.files.length) {
      const [file] = event.target.files;
      this.new_attachment = file
    }
  }

  openUpdateAttachmentModal(uploadType:string,uploadRef:string,fileURL:string){
    this.file_url=fileURL;
    this.upload_type=uploadType;
    this.upload_ref=uploadRef;

    if (this.modalUpdateVehicleAttachments) {
      (<any>$(this.modalUpdateVehicleAttachments.nativeElement)).modal('show');
    }
  }

  closeUpdateAttachmentModal():void {
    if (this.modalUpdateVehicleAttachments) {
      (<any>$(this.modalUpdateVehicleAttachments.nativeElement)).modal('hide');

      //Refresh attachments list
      this.isLoading=true;
      this.getVehicleAttachments(this.vehicle_id);
    }
  }

  openAddAttachmentModal(){
    if (this.modalAddAttachment) {
      (<any>$(this.modalAddAttachment.nativeElement)).modal('show');
    }
  }

  onSelectChange(target: EventTarget|null) {
    if (target instanceof HTMLSelectElement) {
      const selectedOption = target.value;

      if(selectedOption ==='Other'){
        this.docNameIsRequired=true;
      }else{
        this.docNameIsRequired=false;
      }
    }
  }

  updateAttachment(){
    this.submitted = true;
    this.isProcessing=true;

    if (this.form.valid) {
      this.viewAttachmentsService.updateVehicleAttachment(this.upload_type,this.upload_ref,this.vehicle_id,this.file_url,this.attachment)
      .subscribe({
        next: (response) => {
          if(response.status==='success'){
            this.submitted = false;
            this.isProcessing=false;
            this.attachment = null;
            this.replacementFileName ="Choose an image or a PDF file";
            this.globalService.setGlobalSuccessMessage(response.message);
            this.closeUpdateAttachmentModal();
          }else if(response.status==='error'){
            this.submitted = false;
            this.isProcessing=false;
            this.popupErrorMessage=response.message;
          }else if(response.status==='warning'){
            this.submitted = false;
            this.isProcessing=false;
            this.popupWarningMessage=response.message;
          }else{
            this.submitted = false;
            this.isProcessing=false;
            this.popupErrorMessage=response.message;
          }
        },
        error: (error) => {
          this.submitted = false;
          this.isProcessing=false;
          this.popupErrorMessage=error;
        }
      });
    }else{
      this.isProcessing=false;
    }
  }

  uploadNewAttachment(){
    this.submitted = true;
    this.isProcessing=true;

    if (this.addAttachmentForm.valid) {
      this.viewAttachmentsService.addNewVehicleAttachment(this.vehicle_id,this.addAttachmentForm.value,this.new_attachment)
      .subscribe({
        next: (response) => {
          if(response.status==='success'){
            this.submitted = false;
            this.isProcessing=false;
            this.attachment = null;
            this.newAttachmentFileName ="Choose an image or a PDF file";
            this.globalService.setGlobalSuccessMessage(response.message);
            //Reset modal form
            this.addAttachmentForm.reset();
            //Close modal
            (<any>$(this.modalAddAttachment.nativeElement)).modal('hide');
            //Refresh attachments list
            this.isLoading=true;
            this.getVehicleAttachments(this.vehicle_id);
          }else if(response.status==='error'){
            this.submitted = false;
            this.isProcessing=false;
            this.newAttPopupErrorMessage=response.message;
          }else if(response.status==='warning'){
            this.submitted = false;
            this.isProcessing=false;
            this.newAttPopupWarningMessage=response.message;
          }else{
            this.submitted = false;
            this.isProcessing=false;
            this.newAttPopupErrorMessage=response.message;
          }
        },
        error: (error) => {
          this.submitted = false;
          this.isProcessing=false;
          this.newAttPopupErrorMessage=error;
        }
      });
    }else{
      this.isProcessing=false;
    }
  }
}
